import RecordItem from "../RecordItem/RecordItem";
import "./ListRecords.css";
import { useEffect } from "react";
import { useRecords } from "../../hooks/useRecords";
import { getRecordsDb } from "../../controllers/getRecords";
import { IRecord } from "../../interfaces/interfaces";

interface ListRecordsProps {
  setEditPopUp: any;
}

const ListRecords = ({ setEditPopUp }: ListRecordsProps) => {
  const { records, getRecords } = useRecords();

  useEffect(() => {
    if (records.length === 0) {
      getRecordsDb().then((response) => {
        if (response) {
          getRecords(response);
        }
      });
    }
  }, []);

  return (
    <div
      className="List-box"
      style={
        records.length > 5 ? { overflowY: "scroll" } : { overflowY: "visible" }
      }
    >
      {records.length > 0 &&
        records.map((record: IRecord) => {
          return (
            <RecordItem
              key={record._id}
              record={record}
              setEditPopUp={setEditPopUp}
            />
          );
        })}
    </div>
  );
};
export default ListRecords;
